import { Component, computed, contentChild, ChangeDetectionStrategy } from '@angular/core';
import { ButtonComponent } from '../../basic/button/button.component';
import { PageCommandGroupComponent } from '../../misc/page-command-group/page-command-group.component';
import { PageCommand, PageCommandType } from '../../misc/page-command/page-command.component';
import { ButtonPrimaryDirective } from 'src/app/controls/directives/button-primary.directive';
import { ButtonSecondaryDirective } from 'src/app/controls/directives/button-secondary.directive';
import { ButtonTertieryDirective } from 'src/app/controls/directives/button-tertiery.directive';

@Component({
  selector: 'app-page-footer',
  standalone: true,
  imports: [ButtonComponent, ButtonPrimaryDirective, ButtonSecondaryDirective, ButtonTertieryDirective],
  templateUrl: './page-footer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './page-footer.component.scss'
})
export class PageFooterComponent {
  commandGroup = contentChild(PageCommandGroupComponent);

  inputCommands = computed(() => this.commandGroup()?.commands() ?? []);

  readonly PageCommandType = PageCommandType;
  
  //These are the default commands with a fixed position, text and icon.
  defaultPageCommands: PageCommand[] = [
    { name: 'save', text: 'Save', type: PageCommandType.Primary, icon: 'dx-icon-save', action: () => {}, requiredPermissions: [], disabled: false },
    { name: 'cancel', text: 'Cancel', type: PageCommandType.Secondary, icon: 'dx-icon-revert', action: () => {}, requiredPermissions: [], disabled: false },
  ];

  visiblePageCommands = computed(() => {
    let visibleDefaultPageCommands = this.defaultPageCommands.filter(defaultCommand => this.inputCommands().some(inputCommand => inputCommand.name === defaultCommand.name));
    visibleDefaultPageCommands = visibleDefaultPageCommands.map(defaultPageCommand => {
      const inputCommand = this.inputCommands().find(command => command.name === defaultPageCommand.name);
      const defaultCommand = inputCommand?.action ? { ...defaultPageCommand, action: inputCommand.action, disabled: inputCommand.disabled } : defaultPageCommand;
      return defaultCommand;
    });

    const customCommands = this.inputCommands().filter(inputCommand => !visibleDefaultPageCommands.some(defaultCommand => defaultCommand.name === inputCommand.name));

    return [ ...visibleDefaultPageCommands, ...customCommands];
  });
}
